import { CreateEmployeeDto, UpdateEmployeeDto } from '../models'
import axiosClient from './axiosClient'

const PATH = '/employees'

export const employeeApi = {
  getEmployees: () =>
    axiosClient.get(PATH, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createEmployee: (createEmployeeDto: CreateEmployeeDto) =>
    axiosClient.post(PATH, createEmployeeDto, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateEmployee: (id: number, updateEmployeeDto: UpdateEmployeeDto) =>
    axiosClient.put(`${PATH}/${id}`, updateEmployeeDto, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  deleteEmployee: (id: number) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
